<template>
  <div>
    <div class="wacg-body text-center">
      <v-layout row wrap class="action-items-list">
        <v-flex
            md4
            xs6
            class="safari-clear-fix"
            v-for="(feature,index) in features"
            :key="index"
            :class="{'disable-ie': checkIE(feature.name)}"
        >
          <component v-if="feature.name !== 'الترجمة'" :is="feature.name" :data="feature" @countAnalytics="countAnalytics"></component>
          <component v-else :is="'Translate'" :data="feature" @countAnalytics="countAnalytics" />
        </v-flex>
      </v-layout>
    </div>

<!--    <div class="d-flex px-2 mt-2 wacg-contac-info justify-space-between">-->
<!--      <div>-->
<!--        <a href="https://www.bluecrunch.com/contact/" target="_blank">-->
<!--          <h3 class="d-flex align-center">-->
<!--            <v-icon size="14">icon-Contact-Us</v-icon>-->
<!--            <span class="mx-1 d-inline-block">{{$t("Contact us")}}</span>-->

<!--          </h3>-->
<!--        </a>-->
<!--      </div>-->
<!--      <div>-->
<!--        <h3>{{$t("Powerd by Bluecrunch")}}</h3>-->
<!--      </div>-->
<!--    </div>-->
  </div>

</template>

<script>
    import brightness from "./selectors/brightness";
    import highlightLinks from "./selectors/links";
    import highlightTitles from './selectors/titles'
    import fontSize from './selectors/font-size'
    import letterSpacing from "./selectors/spacing";
    import legibleFont from "./selectors/font";
    import magnifyCursor from "./selectors/cursor";
    import textToSpeech from './selectors/text-to-speech'
    import toolTip from './selectors/tool-tip'
    import readingGuide from './selectors/reading-guide'
    import disableAnimation from './selectors/disable-js'
    import textMagnify from './selectors/text-magnify'
    import Translate from "@/components/selectors/translate";
    import signLanguage from './selectors/sign-language'
    export default {
        name: "wacg-body",
        components: {
            brightness,
            highlightLinks,
            highlightTitles,
            fontSize,
            letterSpacing,
            legibleFont,
            magnifyCursor,
            textToSpeech,
            toolTip,
            readingGuide,
            disableAnimation,
            textMagnify,
            Translate,
            signLanguage
        },
        props: {
            features: {
                type: Array,
                default: ()=> {
                    return []
                }
            },
            settings: {
                type: Object,
                default: ()=> {
                    return {}
                }
            }
        },
        data() {
            return {
                featuresIeSupport: [
                    'disable-animation',
                    'legible-font',
                    'highlight-links',
                    'highlight-titles',
                    'text-to-speech',
                    'text-magnify',
                    'letter-spacing',
                    'tool-tip',
                    'Translate'
                ]
            }
        },
        mounted() {

        },
        methods: {
            countAnalytics(featureId) {
                this.$http.get(`/record?customerId=${this.settings._id}&featureId=${featureId}`)
            },
            checkIE(feature) {
                return ! this.featuresIeSupport.includes(feature)
            }
        },
        computed: {
            userid() {
                const divAttr = document.getElementById('wacg-wrapper')
                if (divAttr) {
                    return divAttr.getAttribute('data-wacgid')
                } else {
                    return  null
                }
            }
        }
    }
</script>

<style>


    @media screen and (min-color-index:0) and(-webkit-min-device-pixel-ratio:0) {
        @media {
            .safari-clear-fix {
                flex-basis: 49% !important;
            }
        }
    }

    @media screen and (min-color-index:0) and(-webkit-min-device-pixel-ratio:0) {
        @media {
            .safari-clear-fix {
                flex-basis: 49% !important;
            }
        }
    }

    @media not all and (min-resolution:.001dpcm) {
        @media {
            .safari-clear-fix {
                flex-basis: 49% !important;
            }
        }
    }

    @media not all and (min-resolution:.001dpcm) {
        @media {
            .safari-clear-fix {
                flex-basis: 49% !important;
            }
        }
    }
</style>
